var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 15,
    viewBox: "0 0 4 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.18982 1.59446C3.18982 0.714553 2.47502 -3.12447e-08 1.59482 -6.97196e-08C0.715801 -1.08143e-07 0.00100514 0.714553 0.0010051 1.59446C0.00100506 2.47436 0.7158 3.18891 1.59482 3.18891C2.47502 3.18891 3.18982 2.47436 3.18982 1.59446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59494 9.09446C2.47396 9.09446 3.18994 8.37991 3.18994 7.50001C3.18994 6.6201 2.47396 5.90555 1.59494 5.90555C0.715923 5.90555 -5.41523e-05 6.6201 -5.41907e-05 7.50001C-5.42292e-05 8.37991 0.715922 9.09446 1.59494 9.09446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59494 15C2.47396 15 3.18994 14.2855 3.18994 13.4056C3.18994 12.5256 2.47396 11.8111 1.59494 11.8111C0.715923 11.8111 -5.41523e-05 12.5256 -5.41907e-05 13.4056C-5.42292e-05 14.2855 0.715922 15 1.59494 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/moreIcon.1129cf8bc934224bccbdc55267693f20.svg";
export { ForwardRef as ReactComponent };